// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	ForgotPassword: 'forgot-password',
	SignUpLink: 'sign-up-link',
	Email: 'email',
	Password: 'password',
} as const;
